<template>
    <div>
        <div :class="['alert-'+msgClass]" class="alert alert-dismissible fade show col-md-10" role="alert" style="margin-left: 9%;">
            <pre style="white-space: pre-wrap; padding: 0 3px; margin-bottom: 0;">{{message}}</pre>
            <button v-if="!disableClose" type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>


<script>
export default {
        name: 'msg',
        props:['message','msgClass','visible','disableClose'],
        data(){
            return {}
        }
}
</script>